var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { CaseInfoService } from "~/services/business-service/case-info.service";
import { differenceInDays } from "date-fns";
var collectionManageModule = namespace("collection-manage");
var TopCaseBaseInfo = /** @class */ (function (_super) {
    __extends(TopCaseBaseInfo, _super);
    function TopCaseBaseInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debtCase = {};
        return _this;
    }
    TopCaseBaseInfo.prototype.onCaseIdChanged = function (val) {
        if (!val)
            return;
        this.searchDebtCaseCount();
    };
    TopCaseBaseInfo.prototype.mounted = function () {
    };
    TopCaseBaseInfo.prototype.searchDebtCaseCount = function () {
        var _this = this;
        var queryParamsModel = {
            certificateNo: this.currentCase.certificateNo,
            principalId: this.currentCase.principalId
        };
        this.caseInfoService.searchDebtCaseCount(queryParamsModel)
            .subscribe(function (data) { return _this.debtCase = data; });
    };
    TopCaseBaseInfo.prototype.created = function () {
    };
    Object.defineProperty(TopCaseBaseInfo.prototype, "returnDays", {
        get: function () {
            if (!this.currentCase.endCaseDate)
                return null;
            else {
                return differenceInDays(this.currentCase.endCaseDate, new Date()) + 1;
            }
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Dependencies(CaseInfoService)
    ], TopCaseBaseInfo.prototype, "caseInfoService", void 0);
    __decorate([
        collectionManageModule.State
    ], TopCaseBaseInfo.prototype, "currentCase", void 0);
    __decorate([
        Watch("currentCase", { immediate: false })
    ], TopCaseBaseInfo.prototype, "onCaseIdChanged", null);
    TopCaseBaseInfo = __decorate([
        Component({
            components: {}
        })
    ], TopCaseBaseInfo);
    return TopCaseBaseInfo;
}(Vue));
export default TopCaseBaseInfo;
